import React from 'react';

import { TagList } from '../../../../../shared/components/Tag';
import { useCalendar } from '../../../hooks';
import ConnectGoogleButton from './ConnectGoogleButton';

const Footer = () => {
  const { tags } = useCalendar();

  return (
    <div className="flex items-center justify-between p-2 border-t">
      <ConnectGoogleButton />
      <TagList tags={tags} />
    </div>
  );
};

export default Footer;
